import { render } from "./ListeSuiviCommandePage.vue?vue&type=template&id=a83a7a7c&ts=true"
import script from "./ListeSuiviCommandePage.vue?vue&type=script&lang=ts"
export * from "./ListeSuiviCommandePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__